import { render } from "./VmenuItem.vue?vue&type=template&id=d019cf76"
import script from "./VmenuItem.vue?vue&type=script&lang=js"
export * from "./VmenuItem.vue?vue&type=script&lang=js"

import exportComponent from "C:\\TK\\LivppyLab\\LivppyLab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__